module.exports = __webpack_public_path__ + "img/COULD1.a928c81e.png";